module.exports = __webpack_public_path__ + "img/合作伙伴banner.0a13ab4c.png";